// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-Search-search-module__root","content":"applications-components-ProductsApp-components-Search-search-module__content","input":"applications-components-ProductsApp-components-Search-search-module__input","separator":"applications-components-ProductsApp-components-Search-search-module__separator"};
    if(module.hot) {
      // 1791528099499
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  